import * as z from "zod";

// The images of the emails of Guestlist (ADR-293): in the bucket of crm, named by the SHA-256 of their bytes, so an
// email already sent never loses one and the same image is stored once. Only what every client shows: no SVG, no WebP.

export const emailAssetId = z.string().regex(/^[0-9a-f]{64}$/, "The SHA-256 of the image, in hex");

export const emailAssetContentTypes = ["image/png", "image/jpeg", "image/gif"] as const;
export type EmailAssetContentType = (typeof emailAssetContentTypes)[number];

/** Above this an image slows every email it is in; a logo or a photo for 600 px stays well under it. */
export const EMAIL_ASSET_MAX_BYTES = 1_000_000;

/** The bytes of an image, streamed by the gateway; the domain reads its type from the bytes, not from the name. */
export const uploadEmailAssetInput = z.object({
  sizeBytes: z.number().int().min(1).max(EMAIL_ASSET_MAX_BYTES),
  content: z.custom<ReadableStream<Uint8Array>>((value) => value instanceof ReadableStream),
});
export type UploadEmailAssetInput = z.input<typeof uploadEmailAssetInput>;
/** `Content-Length` of an upload, not a field of the route: a browser sets it itself (gateway-guestlist). */
export const emailAssetSize = z.coerce.number().pipe(uploadEmailAssetInput.shape.sizeBytes);

/** The public read of an image (crm-images, ADR-294): by its hash alone, without an Actor. */
export const readEmailAssetInput = z.object({ id: emailAssetId });
export type ReadEmailAssetInput = z.input<typeof readEmailAssetInput>;

export const emailAssetDto = z
  .object({
    id: emailAssetId,
    contentType: z.enum(emailAssetContentTypes),
    sizeBytes: z.number().int(),
    /** In pixels, from the header of the image: Outlook needs the width written on the tag. */
    width: z.number().int(),
    height: z.number().int(),
    /** Where crm-images serves it: the same address in the editor and in what is sent (ADR-295). */
    url: z.url(),
    createdAt: z.iso.datetime(),
  })
  .meta({ id: "EmailAsset" });
export type EmailAssetDto = z.output<typeof emailAssetDto>;
